import CommonFilterStore from '../CommonFilter/Store';

class LanguageFilterStore extends CommonFilterStore {
  getFilterValues(): string[] {
    return this._filters.availableLanguages.map((l) => l.payload.code);
  }
}

export default LanguageFilterStore;
